module.exports = __webpack_public_path__ + "static/media/ellipse.9e6be14e.svg";